import { getField } from 'vuex-map-fields';
export default {
    getLoginField(state) {
        return getField(state.loginForm);
    },
    getResetPasswordField(state) {
        return getField(state.resetPasswordForm);
    },
    getChangePasswordField(state) {
        return getField(state.changePasswordForm);
    },
}